export const messages = {
  en: {
    messages: {
      pleaseQRcode: "Hold the QR code over the reader.",
      saveQRcode:
        "If you don't import the QR code immediately,\ntap the QR code and save it as an image.",
      qrSize: "QR code size"
    },
    validations: {
      required: "{_field_} is a required.",
      max: "Enter {_field_} in {length} digits.",
      email: "Please enter your email address for {_field_}.",
      alphaDash:
        "{_field_} may contain alpha-numeric characters as well as dashes and underscores.",
      dateFormat: "Enter {_field_} in date format ({format})",
      optionTextArea: "Please enter characters for the text area of {_field_}.",
      qrCharacterNumber:
        "Please reduce the number of characters because the character limit of QR is exceeded.",
      integer: "Please enter single-byte integers for {_field_}.",
      decimal: "Please enter single-byte decimals for {_field_}.",
      integerordecimal:
        "Please enter single-byte decimals or integers for {_field_}.",
      double: "Enter a unique value for {_field_}.",
      surveyItemNumber: "Add a survey item.",
      survey:
        "Errors in the %{languages} survey. Check the errors and correct them.",
      invalidFilename:
        "The survey ID and file name do not match. Please use the file name downloaded by Editor as it is."
    },
    buttons: {
      generateQR: "Generate QR",
      back: "Back",
      close: "Close",
      ok: "Yes",
      cancel: "Cancel",
      exsit: "Exsit"
    },
    dialogs: {
      confirmation: "Confirmation",
      surveyValidationError: "Survey content error",
      qrValidationError: "QR generation error",
      messages: {
        initSurvey: "Delete your answer and back to the survey form."
      }
    },
    fontSizes: {
      small: "Small",
      medium: "Medium",
      large: "Large"
    }
  },
  ja: {
    messages: {
      pleaseQRcode: "QRコードをリーダーにかざしてください。",
      saveQRcode:
        "すぐに取込しない場合は\nQRコードをタップし画像として保存してください。",
      qrSize: "QRコードの大きさ"
    },
    validations: {
      required: "{_field_}は必須項目です。",
      max: "{_field_}は{length}桁以下で入力してください。",
      email: "{_field_}はメールアドレスを入力してください。",
      alphaDash:
        "{_field_}は英数字とハイフン、アンダースコアのみ使用できます。",
      dateFormat: "{_field_}は日付形式({format})で入力してください",
      optionTextArea: "{_field_}のテキストエリアに文字を入力してください。",
      qrCharacterNumber:
        "QRの文字数上限を超えているため、文字数を減らしてください。",
      integer: "{_field_}は半角の整数を入力してください。",
      decimal: "{_field_}は半角の小数を入力してください。",
      integerordecimal: "{_field_}は半角の小数または整数を入力してください。",
      double: "{_field_}は一意の値を入力してください。",
      surveyItemNumber: "アンケート項目を追加してください。",
      survey:
        "%{languages}のアンケートにエラーがあります。エラ―内容をご確認の上、修正してください。",
      invalidFilename:
        "アンケートIDとファイル名が一致しません。Editorでダウンロードしたファイル名をそのままご利用ください。"
    },
    buttons: {
      generateQR: "QR生成",
      back: "戻る",
      close: "閉じる",
      ok: "はい",
      cancel: "キャンセル",
      exsit: "終了"
    },
    dialogs: {
      confirmation: "確認画面",
      surveyValidationError: "アンケート内容エラー",
      qrValidationError: "QR生成エラー",
      messages: {
        initSurvey: "アンケート回答を削除の上、アンケート入力画面に戻ります。"
      }
    },
    fontSizes: {
      small: "小",
      medium: "中",
      large: "大"
    }
  }
};
